import { safeGetJson } from '@/helpers/safeLocalStorage'

export default {
  graphsSettings: {
    mode: null,
  },
  commonData: {
    selectedUnit: safeGetJson('autoscheduleSelectedUnit', {}),
    selectedMonth: safeGetJson('autoscheduleSelectedMonth', ''),
    selectedMaster: safeGetJson('autoscheduleSelectedMaster', {}),
    units: [],
    autoscheduleSettings: {},
  },
  statistics: {
    graphData: {},
    getDataInProgress: false,
    statisticsError: false,
  },
  forecasting: {
    graphData: {},
    workplacesNumber: null,
    schedulesDataForGraph: [],
    graphDayPointIndex: 0,
    getDataInProgress: false,
    statisticsError: false,
    tableInProgress: false,
    ceilUpdatingInProgress: false,
    scheduleData: [],
    daysData: {},
    opinionData: [],
    quarantineData: [],
  },
  masterPage: {
    opinionData: {},
    ratingObject: {
      rating: [],
      ratingCoeffValue: 0,
    },
  },
  mastersTable: {
    employerWishesData: {},
    settings: {},
    data: [],
    inProgress: false,
    error: false,
  },
}
